// extracted by mini-css-extract-plugin
export var heading = "ComponentTextWithToc-module--heading--8b42c";
export var noToc = "ComponentTextWithToc-module--noToc--e4e38";
export var section = "ComponentTextWithToc-module--section--97468";
export var text = "ComponentTextWithToc-module--text--94c67";
export var tocDesktop = "ComponentTextWithToc-module--tocDesktop--53587";
export var tocMobile = "ComponentTextWithToc-module--tocMobile--4d536";